import type { parseFilterModel } from '@/lib/createAgGridDatasource';
import { buildDownloadOptions as buildDownloadOptionsShared, type SortColumnState } from '@/lib/downloadOptions';
import type { StudiesDownloadOptions } from '@/services/studies';
import type { StudyFilters, StudySortField } from '@/types';

// The StudySortField values the backend actually resolves — org_name/updated_by_full_name are
// grid-sortable but have no backend counterpart, same as instrument_runs' own exceptions.
export const VALID_SORT_FIELDS: readonly StudySortField[] = [
  'name',
  'description',
  'created_at',
  'updated_at',
  'created_by_full_name',
  'num_samples',
];

// StudyFilters' actual keys (src/types/api.ts) — the grid also filters on org_name/num_samples,
// neither of which this endpoint's filter contract supports.
const VALID_FILTER_FIELDS: readonly (keyof StudyFilters)[] = [
  'name',
  'description',
  'created_by_full_name',
  'updated_by_full_name',
  'created_at',
  'updated_at',
];

/**
 * Pure translation of the grid's current sort/filter state into the CSV export's options.
 * Kept out of the route component so the sort-field gate and the filters-length branch can be
 * unit tested without mounting the grid.
 */
export function buildDownloadOptions(
  columnState: readonly SortColumnState[],
  filterModel: Parameters<typeof parseFilterModel>[0],
): StudiesDownloadOptions {
  return buildDownloadOptionsShared(columnState, filterModel, VALID_SORT_FIELDS, VALID_FILTER_FIELDS);
}
